export class CheckoutDto {
  priceId: string
  accountId?: string
  userId: string
  
  successUrl?: string
  cancelUrl?: string
  
  checkoutUrl: string
}
